import { Observable, Subject } from 'rxjs';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { UserProfile } from '../../models/user';
import { SessionService } from '../auth/session.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PlanTypeActionModel } from '../../models/user-management/plan-type-action-model';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  planActionList: Array<PlanTypeActionModel>;
  userInfo!: UserProfile;
  isNavbarShow = true;
  isSidebarShow = true;

  constructor(private http: HttpClient, private sessionService: SessionService) {
    this.planActionList = [];
    this.fetchUserProfile();
  }

  fetchUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((result: UserProfile) => {
      this.userInfo = result;
      if (this.userInfo) {
        this.fetchPlanTypeAction();
      } else {
        this.fetchUserProfile();
      }
    });
  }

  fetchPlanTypeAction(): void {
    this.getUserPlanTypeAction().subscribe((data: PlanTypeActionModel[]) => {
      this.planActionList = data;
    });
  }

  checkPlanTypeAction(actionCode: string): boolean {
    const index = this.planActionList.findIndex(a => a.actionCode === actionCode && a.planType === this.userInfo.planType);
    return index >= 0 ? true : false;
  }

  getUserPlanTypeAction(): Observable<Array<PlanTypeActionModel>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Array<PlanTypeActionModel>>(`${environment.config.baseAppURL}/UserManagement/GetUserPlanTypeAction`, { headers });
  }
  
}
